import VideoView from './VideoView'

export default VideoView
